import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "providerapp/pagination";
import {ParentCaseInfo, ParentCaseSortBy, ParentCaseStatus, SortOrder} from "./domain";
import {ParentCaseListFilterValue} from "./ParentCaseListFilter";
import {DEFAULT_PAGE_SIZE} from "../const";

export type ParentCaseListAction =
    | { type: 'SET_SELECTED'; selected: ParentCaseInfo | null }
    | { type: 'SET_SORT_BY'; sortBy: ParentCaseSortBy }
    | { type: 'SET_SEARCH'; search: string }
    | { type: 'SET_FILTER'; filter: ParentCaseListFilterValue }
    | { type: 'SET_PAGE_SIZE'; pageSize: number }
    | RelayPaginationActionPayload;


export interface ParentCaseListState {
    pagination: RelayPaginationState;
    sortBy: ParentCaseSortBy;
    filter: ParentCaseListFilterValue
    selected: ParentCaseInfo | null;
    search: string;
    pageSize: number;
}


export function initState(): ParentCaseListState {
    const defaultPagination = new RelayPaginationState('0', DEFAULT_PAGE_SIZE);
    return {
        pagination: defaultPagination,
        pageSize: defaultPagination.size,
        selected: null,
        search: "",
        filter: {
            serviceType: "",
            cpaStatus: ParentCaseStatus.Active,
            cities: "",
            fromDate: null,
            toDate: null,
        },
        sortBy: {
            column: "caseNumber",
            order: SortOrder.DESC,
        },
    };
}

export function parentCaseListReducer(
    state: ParentCaseListState,
    action: ParentCaseListAction
): ParentCaseListState {
    switch (action.type) {
        case 'SET_SELECTED':
            return {
                ...state,
                selected: action.selected
            }
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
        case 'SET_SORT_BY':
            return {
                ...state,
                sortBy: action.sortBy
            };
        case 'SET_SEARCH':
            return {
                ...state,
                search: action.search,
                pagination: new RelayPaginationState('0', state.pageSize),
            };
        case 'SET_FILTER':
            return {
                ...state,
                filter: action.filter,
                pagination: new RelayPaginationState('0', state.pageSize),
            }
        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pageSize: action.pageSize,
                pagination: new RelayPaginationState('0', action.pageSize),
            };
        default:
            return state;
    }
}
